/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Form_LabelInputs */



/**
* | output |
* | --- |
* | "Export Configuration" |
*
* @param {Transcript_Export_Form_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_form_label = /** @type {((inputs?: Transcript_Export_Form_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Form_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Configuration de l'exportation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Exportkonfiguration")
	if (locale === "it") return /** @type {LocalizedString} */ ("Configurazione di esportazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт конфигурации")
	if (locale === "es") return /** @type {LocalizedString} */ ("Configuración de exportación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导出配置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エクスポート設定")
	if (locale === "hi") return /** @type {LocalizedString} */ ("निर्यात कॉन्फ़िगरेशन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportar configuração")
	return /** @type {LocalizedString} */ ("Export Configuration")
});